import { useQuery, queryOptions } from '@tanstack/react-query';

import { STALE_TIMES } from '#lib/queryConstants';

import { fetchToneOfVoices } from '../../api/toneOfVoicesApi';

import { toneOfVoicesKeys } from './keys';

export const toneOfVoicesOptions = () =>
	queryOptions({
		queryKey: toneOfVoicesKeys.list(),
		queryFn: fetchToneOfVoices,
		staleTime: STALE_TIMES.STABLE,
		retry: 2,
	});

export function useAllToneOfVoices() {
	return useQuery(toneOfVoicesOptions());
}
